var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.938 18",
    fill: "currentColor",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.649,981.72a0.8,0.8,0,0,0-.569-0.24H95.664v-0.819a0.823,0.823,0,0,0-.288-0.627,0.8,0.8,0,0,0-.657-0.179l-9.125,1.637a0.815,0.815,0,0,0-.665.806v13.09a0.815,0.815,0,0,0,.665.806l9.125,1.636a0.739,0.739,0,0,0,.14.013,0.8,0.8,0,0,0,.517-0.192,0.823,0.823,0,0,0,.288-0.627v-0.818h2.416a0.812,0.812,0,0,0,.805-0.818V982.3A0.823,0.823,0,0,0,98.649,981.72Zm-4.595.579V996.05L86.539,994.7V982.986l7.515-1.349V982.3Zm3.221,12.272h-1.61V983.117h1.61v11.454h0Zm-5.067-5.761a0.8,0.8,0,0,0-1.139,0,0.829,0.829,0,0,0,0,1.158,0.8,0.8,0,0,0,1.139,0A0.829,0.829,0,0,0,92.208,988.81Z",
    transform: "translate(-84.938 -979.844)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.5f2762ca.svg";
export { ForwardRef as ReactComponent };